// TWO PIXEL SPACES, AND THE NUMBER THAT WAS PASSED BETWEEN THEM.
//
// The tracking page renders with `zoom: 0.8` on the root element
// (measured on staging, 2026-09-24). CSS zoom scales RENDERED geometry,
// so the two things the box-select code was mixing are not the same
// unit:
//   getBoundingClientRect() / event.clientX  -> ZOOMED pixels
//   style.left / style.width                 -> UNZOOMED CSS pixels
//
// local() produced a zoomed distance and assigned it straight to
// style.left, so 30 rendered as 24: the rectangle started 20% of the
// way back toward the canvas origin. The error is PROPORTIONAL to the
// distance from that origin - 6 px at 30 px in, 60 px at 300 px in -
// which is why a press near the corner looks nearly right and a press
// across the model looks badly wrong.
//
// WHY THE RATIO AND NOT THE `zoom` PROPERTY: reading zoom would fix
// today's cause only. Measuring the canvas's own RENDERED size against
// its LAYOUT size captures zoom, a CSS transform on any ancestor, and
// anything else that scales the element - so a later transform cannot
// quietly defeat it. It is also the same ratio that makes the drawing
// buffer look 1.25x the CSS size on that page: offsetWidth is layout
// pixels, getBoundingClientRect().width is rendered ones.
import { cssPixelScale } from '../../../helpers/pointerToStyle';

// The scale itself lives in helpers/pointerToStyle - it is the same
// question the resizable divider asks, and two copies of it would be
// two places to fix when the next element needs it.
export { cssPixelScale };

// The rectangle, converted from the space the pointer was measured in
// into the space `style` is interpreted in.
export function overlayRectStyle(box, scale) {
  const s = Number.isFinite(Number(scale)) && Number(scale) > 0 ? Number(scale) : 1;
  const x = Math.min(box.x0, box.x1);
  const y = Math.min(box.y0, box.y1);
  const w = Math.abs(box.x1 - box.x0);
  const h = Math.abs(box.y1 - box.y0);
  return {
    left: `${x / s}px`,
    top: `${y / s}px`,
    width: `${w / s}px`,
    height: `${h / s}px`,
  };
}
